// extracted by mini-css-extract-plugin
module.exports = {"about":"AboutPage_about__EUhVp","text":"AboutPage_text__3ZXHt"};